import type { ReactNode } from "react";
import { Button, Grid } from "@mui/material";
import { useSnackbarErrorHandler } from "utils/errorHandling";
import { excelUtil } from "utils";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

function AgExportButton(): ReactNode {
  const { catchErrors, isLoading } = useSnackbarErrorHandler();

  return (
    <Grid>
      <Button
        onClick={() => {
          void catchErrors(excelUtil.createExportAssembleeGenerale);
        }}
        loading={isLoading}
        size="small"
        variant="text"
        color="inherit"
        loadingPosition="start"
        startIcon={<FileDownloadIcon />}>
        Délégués à l'Assemblée Générale
      </Button>
    </Grid>
  );
}

export default AgExportButton;
